<template>
  <div class="container">
    <div class="sf-site-all">
      <div class="sf-site-content">
        <div class="columns">
          <div class="column">
            <h6 class="title is-6 is-pulled-left">TaskNo.{{ tasks_data.task.id }}</h6>
          </div>
        </div>
        <!-- タスク内容 -->
        <div class="columns">
          <div class="column is-9-desktop is-8-tablet">
            <h5 v-if="!isEdit" class="title is-5 is-pulled-left">{{ tasks_data.task.task_title }}</h5>
            <div v-else class="control">
              <input class="input" type="text" placeholder="件名" v-model="tasks_data.task.task_title">
            </div>
          </div>
          <div class="column is-3-desktop is-4-tablet">
            <h6 class="title is-6 is-pulled-right" v-if="!isEdit">登録日時:{{ tasks_data.task.created_at }}</h6>
            <div class="control is-6 is-pulled-right" v-else>
              <flat-pickr v-model="tasks_data.task.created_at" class="input" :config="config"></flat-pickr>
            </div>
          </div>
        </div>
        <!-- タスク内容詳細 -->
        <div class="columns is-multiline">
          <div class="column is-10-desktop is-8-tablet">
            <div class="box">
              <!-- コメント -->
              <div class="columns has-text-left is-multiline">
                <div class="column is-11-desktop is-10-tablet">
                  <pre v-if="!isEdit" class="code_break">{{ tasks_data.task.comment }}</pre>
                  <div v-else class="field control">
                    <div class="control">
                      <textarea class="textarea" placeholder="詳細" v-model="tasks_data.task.comment" maxlength="200"></textarea>
                    </div>
                    <div>
                      <p class="is-size-7">あと{{ 200 - tasks_data.task.comment.length }}文字</p>
                    </div>
                  </div>
                </div>
                <div v-if="isShow">
                  <div v-if="isEdit == false" class="column is-1-desktop is-2-tablet">
                    <a class="button" @click="isEdit = true">編集</a>
                  </div>
                  <div v-else class="column is-1-desktop is-2-tablet">
                    <a class="button is-info" @click="submitTitle">確定</a>
                  </div>
                </div>
              </div>
              <!-- 登録者・担当者 -->
              <div class="columns">
                <div class="column is-6-tablet is-6-desktop">
                  <p class="is-pulled-left">登録者：{{ tasks_data.task.register_name }}</p>
                  <hr>
                </div>
                <div class="column is-6-tablet is-6-desktop">
                  <p class="is-pulled-left">担当者：{{ tasks_data.task.rep_name }}</p>
                  <hr>
                </div>
              </div>
              <!-- ステータス・緊急性 -->
              <div class="columns">
                <div class="column is-6-tablet is-6-desktop">
                  <p class="is-pulled-left">ステータス：{{ tasks_data.task.status_name }}</p>
                  <hr>
                </div>
                <div class="column is-6-tablet is-6-desktop">
                  <p class="is-pulled-left">緊急性：{{ tasks_data.task.urgency_name }}</p>
                  <hr>
                </div>
              </div>
              <!-- '種別（通常・災害）' -->
              <div class="columns">
                <div class="column is-6-tablet is-6-desktop">
                  <p class="is-pulled-left">マップへの表示：{{ tasks_data.task.mapshow }}</p>
                  <hr>
                </div>
                <div class="column is-6-tablet is-6-desktop">
                  <div class="columns">
                    <div class="column is-desktop">
                      <p class="is-pulled-left" v-if="modules.module_mode">モード：{{ tasks_data.task.mode_name }}</p>
                      <hr>
                    </div>
                    <!-- 添付ファイルの確認 -->
                    <div class="column">
                      <a class="button is-info" @click="isModal(null)">全ファイル表示</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="column is-2-desktop is-4-tablet">
            <div id="map"></div>
            <button class="button is-link" @click="showMapModal">地図を大きく表示</button>
          </div>
        </div>
        <!-- タスク変更履歴入力フォーム -->
        <footer class="footer">
          <div class="container">
            <div class="columns">
              <!-- ファイル添付 -->
              <div class="column is-1">
                <div class="field" v-if="rireki.uploadedImage.length < 3">
                  <div class="file">
                    <label class="file-label">
                      <input class="file-input" type="file" name="resume" @change="onFileChange" accept=".jpg,.gif,.png,image/gif,image/jpeg,image/png">
                      <span class="file-cta">
                        <span class="file-icon">
                          <i class="fas fa-upload"></i>
                        </span>
                        <!-- <span class="file-label">
                          添付
                        </span> -->
                      </span>
                    </label>
                  </div>
                </div>
                <div class="columns">
                  <div class="column">
                    <div class="field">
                      <div class="preview-item">
                        <img
                          v-show="viewImage[0]"
                          class="preview-item-file"
                          :src="viewImage[0]"
                          alt=""
                        />
                        <div v-show="viewImage[0]" class="preview-item-btn" @click="remove(0)">
                          <span class="delete">close</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="column">
                    <div class="field">
                      <div class="preview-item">
                        <img
                          v-show="viewImage[1]"
                          class="preview-item-file"
                          :src="viewImage[1]"
                          alt=""
                        />
                        <div v-show="viewImage[1]" class="preview-item-btn" @click="remove(1)">
                          <span class="delete">close</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="columns">
                  <div class="column">
                    <div class="field">
                      <div class="preview-item">
                        <img
                          v-show="viewImage[2]"
                          class="preview-item-file"
                          :src="viewImage[2]"
                          alt=""
                        />
                        <div v-show="viewImage[2]" class="preview-item-btn" @click="remove(2)">
                          <span class="delete">close</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- コメント -->
              <div class="column is-6">
                <div v-if="!editState">
                  <div v-if="rireki.comment ==='' ">
                    <a class="button is-fullwidth has-text-grey-light" @click="changeState">履歴コメントを入力</a>
                  </div>
                  <div v-else>
                    <a class="button is-fullwidth has-text-grey-light" @click="changeState">{{ tmp_comment }}</a>
                  </div>
                </div>
                <div v-else>
                  <textarea v-model="rireki.comment" class="textarea" placeholder="履歴コメント" maxlength="200"></textarea>
                  <div>
                    <p class="is-size-7">あと{{ 200 - rireki.comment.length }}文字</p>
                  </div>
                </div>
              </div>
              <div class="column">
                <div v-if="!editState">
                  <a class="button is-light is-fullwidth" @click="changeState">状態の変更</a>
                </div>
                <div v-else>
                  <button v-for="status in tasks_data.select.status" v-bind:key="status.id" v-bind:class="[status.class === true ? 'button is-link' : 'button']" @click="statusChange(status)">{{ status.name }}</button>
                  <table class="table table-bg-gray is-fullwidth">
                    <thead>
                      <tr>
                        <th>
                          担当者
                          <!-- 担当者 -->
                          <div class="select">
                            <select v-model="rireki.selectRep">
                              <option v-for="rep in tasks_data.select.users" v-bind:key="rep.dispname" v-bind:value="rep.dispname">
                                {{ rep.dispname }}
                              </option>
                            </select>
                          </div>
                        </th>
                        <th>
                          緊急性
                          <div class="select">
                            <select v-model="rireki.selectUrgency">
                              <option v-for="urgency in tasks_data.select.urgencys" v-bind:key="urgency.id" v-bind:value="urgency.name">
                                {{ urgency.name }}
                              </option>
                            </select>
                          </div>
                        </th>
                      </tr>
                      <tr>
                        <th>
                          マップ表示
                          <div class="select">
                            <select v-model="rireki.selectMap">
                              <option v-for="show in mapShows" v-bind:key="show.id" v-bind:value="show.id">
                                {{ show.dispname }}
                              </option>
                            </select>
                          </div>
                        </th>
                        <th>
                          <template v-if="modules.module_mode">
                            <template v-if="isModeSelect">
                              モード変更
                              <div class="select">
                                <select v-model="rireki.selectMode">
                                  <option v-for="mode in modes" v-bind:key="mode.id" v-bind:value="mode.dispname">
                                    {{ mode.dispname }}
                                  </option>
                                </select>
                              </div>
                            </template>
                          </template>
                        </th>
                      </tr>
                    </thead>
                    <tbody></tbody>
                  </table>
                </div>
              </div>
            </div>
            <div v-if="editState">
              <button class="button is-outlined is-mr-3" @click="changeState">閉じる</button>
              <button class="button is-link is-focused" @click="submit" v-bind:disabled="isToggleActive">登  録</button>
            </div>
          </div>
        </footer>
        <!-- タスクログ表示 -->
        <span class="is-pulled-left">履歴({{ tasks_data.task_log.length }}件)</span>
        <h6>変更履歴（降順）</h6>
        <div class="box">
          <div class="media-content">
            <div class="content" v-for="rireki in tasks_data.task_log" v-bind:key="rireki.id">
              <p><strong>{{ rireki.register }}</strong><span class="has-text-grey"> / {{ rireki.created_at }}</span></p>
              <p style="white-space: pre-line;" v-text="rireki.comment"></p>
              <a v-show="rireki.file_list !== ''" class="button is-info" @click="isModal(rireki.id)">添付ファルの確認</a>
              <hr>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 添付ファイル確認モーダル -->
    <file-modal :files="files" ref="filemodal"></file-modal>
    <map-modal :location="tasks_data" ref="mapmodal"></map-modal>
  </div>
</template>

<script>
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'
import file_modal from './file_modal'
import map_modal from './map_modal'
import { mapGetters, mapState } from 'vuex'
import {T_STD, T_PALE, O_STD, BASEGIS} from '../../util.js'
import imageResize from '../../assets/js/imageResize.js'
const maxSize = 1440
import flatPickr from 'vue-flatpickr-component'
import { Japanese } from 'flatpickr/dist/l10n/ja'
import 'flatpickr/dist/flatpickr.css'
import moment from 'moment'

export default {
  data: function(){
    return {
      Map_BaseLayer: {
        "地理院地図 標準": T_STD,
        "地理院地図 淡色": T_PALE,
        "地理院地図 航空写真": BASEGIS,
        "OpenStreetMap 標準": O_STD
      },
      isToggleActive: true,
      lodingText: "",
      editState: false,
      files:{},
      isEdit: false,
      rireki:{
        rireki: '',
        comment: '',
        selectState: '',
        selectUrgency: '',
        selectRep: '',
        register: '',
        fk_register_id: '',
        old_task:{},
        uploadedImage: [],
        selectMap: 0,
        selectMode: '',
      },
      tmp_comment: '',
      viewImage: [],
      map: null,
      mapShows: [
        { "id": 0, "dispname":"非表示" },
        { "id": 1, "dispname":"表示" },
      ],
      modes: [
        { "id": "1" ,"dispname": "通常"},
        { "id": "2" ,"dispname": "災害"},
      ],
      isModeSelect: false,
      config:{
        locale: Japanese,
        altInput: false,
        enableTime: true,
        altFormat: 'Y-m-d H:i',
        dateFormat: 'Y-m-d H:i',
      },
    }
  },
  components: {
    'file-modal': file_modal,
    flatPickr,
    'map-modal': map_modal,
  },
  computed:{
    ...mapState({
      user: state => state.auth.user,
      modules: state => state.auth.modules,
      mode: state=> state.auth.mode,
      apiStatus: state => state.task.apiStatus,
      apiTaskStatus: state => state.task.apiStatus
    }),
    ...mapGetters({
      tasks_data: 'task/task_logs',
    }),
    isShow: function(){
      return this.user.permission.admin === true || this.user.permission.sub_admin === true ? true : false
    }
  },
  mounted() {
    this.$set(this.config, 'maxDate', new Date()) //現在の日付以降の登録はできないようにする
    this.getTask();
  },
  methods:{
    async getTask(){
      await this.$store.dispatch('task/getTask', { key: this.$route.params.q })
      this.isToggleActive = true
      if(this.apiStatus){
        this.classSetter()
        this.setSelectDefualt()
        this.initMap()
        this.isToggleActive = false
      }
    },
    showMapModal(){
      this.$refs.mapmodal.map_show()
    },
    //マップの作成
    initMap(){
      if(this.map !== null) return
      this.map = L.map('map',
        {
          center: L.latLng( this.tasks_data.task.lat, this.tasks_data.task.lon ),
          zoom: 16,
          layers:[ new L.tileLayer('https://cyberjapandata.gsi.go.jp/xyz/std/{z}/{x}/{y}.png', {
            attribution: "<a href='http://www.gsi.go.jp/kikakuchousei/kikakuchousei40182.html' target='_blank'>国土地理院</a>"
          })]
        }
      )
      let marker = L.marker(L.latLng( this.tasks_data.task.lat, this.tasks_data.task.lon ), {
        icon: L.icon({
          iconUrl: 'static/nanikamitsuketa_mitsuketazou.gif',
          iconSize: [48, 48],
        }),
        draggable: false,
      })
      this.map.addLayer(marker)
      //コントロールの追加
      L.control.layers(this.Map_BaseLayer, null, {
        collapsed: true
      }).addTo(this.map)
    },
    //ボタンのクラス指定
    classSetter(){
      this.tasks_data.select.status.forEach(function(e) {
        e.class = this.tasks_data.task.fk_status_id == e.id ? true : false
      }.bind(this))
    },
    changeState(){
      this.tmp_comment = this.rireki.comment
      if(this.tmp_comment.length > 25){
        this.tmp_comment = this.tmp_comment.slice(0, 23) + '....'
      }
      this.editState = !this.editState
    },
    setSelectDefualt(){
      this.rireki.old_task = this.tasks_data.task
      //緊急性のデフォルト値をセット
      this.rireki.selectUrgency = this.tasks_data.task.urgency_name
      //ステータスのデフォルト値をセット
      this.rireki.selectState = this.tasks_data.task.status_name
      //担当者のデフォルト値をセット
      this.rireki.selectRep = this.tasks_data.task.rep_name
      //マップ表示のデフォルト値をセット
      this.rireki.selectMap = this.tasks_data.task.mapshow_id
      //モードのデフォルト値をセット
      this.rireki.selectMode = this.tasks_data.task.mode_name
      this.isModeSelect = false
      if(this.tasks_data.task.mode_name == "通常" && this.user.permission.admin) this.isModeSelect = true
      //登録者のデフォルト値を設定
      this.rireki.register = this.user.dispname
      this.rireki.fk_register_id = this.user.id
    },
    statusChange(selecter){
      this.tasks_data.select.status.forEach(function(element){
        element.class =  false
      }.bind(this))
      selecter.class = true
      this.rireki.selectState = selecter.name
    },
    async submit(){
      //デフォルト選択より変更があるかどうかの判定
      let strMsg = ''
      //緊急性のチェック
      if(this.tasks_data.task.urgency_name !==  this.rireki.selectUrgency) strMsg += `緊急性：${this.tasks_data.task.urgency_name} → ${this.rireki.selectUrgency}` + "\n"
      //ステータスのチェック
      if(this.tasks_data.task.status_name !==  this.rireki.selectState) strMsg += `ステータス：${this.tasks_data.task.status_name} → ${this.rireki.selectState}` + "\n"
      //担当者のチェック
      if(this.tasks_data.task.rep_name !==  this.rireki.selectRep) strMsg += `担当者：${this.tasks_data.task.rep_name} → ${this.rireki.selectRep}` + "\n"
      //マップ表示チェック
      if(this.tasks_data.task.mapshow_id !==  this.rireki.selectMap) strMsg += `マップ表示：${this.tasks_data.task.mapshow} → ${this.mapShows[this.rireki.selectMap].dispname}` + "\n"
      if(this.tasks_data.task.mode_name !== this.rireki.selectMode) strMsg += `モード：${this.tasks_data.task.mode_name} → ${this.rireki.selectMode}` + "\n"
      //変更の有無のチェック
      if(strMsg === '' && this.rireki.comment === '' && this.rireki.uploadedImage.length == 0){
        this.$swal({
          title: '確認',
          text: '状態を変更するかコメントを登録してください',
          icon: 'info',
          confirmButtonText: '戻る',
        })
        return false
      }
      if(strMsg !== '' && this.rireki.comment !== ''){
        //両方変更がある
        this.rireki.rireki = `コメント：\n${this.rireki.comment} \n${strMsg}`;
      }else if(strMsg !== '' && this.rireki.comment === ''){
        //ステータスのみ変更
        this.rireki.rireki = `${strMsg}`;
      }else if(strMsg === '' && this.rireki.comment !== ''){
         //コメント変更のみある場合
        this.rireki.rireki = `コメント：\n${this.rireki.comment}`;
      }
      this.isToggleActive = true
      this.$set(this.rireki, 'key', this.$route.params.q)//post用key
      await this.$store.dispatch('task/editTask', this.rireki)
      if(this.apiStatus){
        this.$swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'タスクを編集しました。',
          showConfirmButton: false,
          timer: 2000
        }).then(() =>{
          this.clearData()
          this.getTask()
        })
      }
    },
    async submitTitle(){
      if(this.tasks_data.task.task_title === ''){
        this.$swal({
          title: '確認',
          text: 'タイトルを入力してください',
          icon: 'info',
          confirmButtonText: '戻る',
        })
        return false
      }
      this.$set(this.tasks_data.task, 'key', this.$route.params.q)//post用key
      await this.$store.dispatch('task/taskTitleUpdate', this.tasks_data.task)
      if(this.apiStatus){
        this.$swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'タスクを編集しました。',
          showConfirmButton: false,
          timer: 2000
        }).then(() =>{
          this.clearData()
        this.getTask()
        })
      }
    },
    clearData(){
      //初期化
      Object.keys(this.rireki).forEach((key) => {
        this.$set(this.rireki, key, '')
      })
      this.$set(this.rireki, 'selectMap', 0)
      this.$set(this.rireki, 'uploadedImage', [])
      this.$set(this, 'viewImage', [])
      this.$set(this, 'tmp_comment', '')
      this.$set(this, 'editState', false)
      this.$set(this, 'isEdit', false)
    },
    async onFileChange(e){
      this.$store.commit('loading/setLoadingStatus', { loading: true } )
      // ユーザーが画像選択したら呼ばれる
      let files = e.target.files || e.dataTransfer.files
      this.editState = true
　　　// imageResize.jsの関数の利用
      const src = await imageResize.pFileReader(files[0])
      this.viewImage.push(src)
      const img = await imageResize.pImage(src)
      const base64 = await imageResize.resizeImage(img, maxSize, 'image/png')
      this.rireki.uploadedImage.push(base64)
      if(base64){
        this.$store.commit('loading/setLoadingStatus', { loading: false } )
      }
    },
    remove(index){
      this.viewImage.splice(index, 1)
      this.rireki.uploadedImage.splice(index, 1)
    },
    isModal(index){
      this.files = this.filteredFiles(index)
      this.$refs.filemodal.show()
    },
    filteredFiles(index){
      if(index === null) return this.tasks_data.img_list
      var files = []
      for(var i in this.tasks_data.img_list){
        var file = this.tasks_data.img_list[i]
        if(file.fk_task_log_key === index){
          files.push(file)
        }
      }
      return files
    }
  },
}
</script>

<style scope>
  #map {
    width: 100%;
    height: 240px;
  }
  hr {
    margin: 1.5em 1.8em 0 0;
    border-top: 2px solid #bbb;
    border-bottom: 1px solid #fff;
  }
  .code_break {
    padding: .5em .2em;
    white-space: pre-wrap;
    word-wrap: break-word;
    overflow: auto;
  }

  .sf-site-all {
    min-height: 90vh; /* 全体の高さを最低でもビューポートの100%にする ※メニューバーあるので高さの調整が必要*/
    display: flex; /* 子クラスを横並びにする */
    flex-direction: column; /* 子クラスの横並びの方向を縦にする */
    margin-top: 10px;
    margin-left: 10px;
    margin-right: 10px;
  }
  .sf-site-content {
    flex: 1; /* flexに1つだけ数値を指定するとその要素は伸びる */
  }
  /* NavbarとBottomにはflexを指定しないので伸びない */
  /* 結果としてページファイルの中味だけが伸びて、ビューポート100%を実現 */
  /* Bottomは下に貼り付く。スティッキーフッターを実現 */

  .is-m-3{
    margin: 0.2em;
  }
  .is-mr-3{
    margin-right: 0.5em;
  }
  .footer{
    padding: .75em;
    border-radius: 10px;
    margin-bottom: 10px; 
    background-color: rgb(201, 201, 201);
    border: 1px solid rgb(165, 165, 165);
  }
  .table-bg-gray{
    background-color: rgb(201, 201, 201);
  }
  .textarea{
    width: 100%;
    height: 10px;
    resize: none;
    overflow: auto;
  }
  .notification{
    padding: 0.2em !important;
  }
</style>
